export default __webpack_public_path__ + "static/react-native-537dbb428a84c1dd5912bfdf781e39fe.svg";